"use strict";

exports.__esModule = true;
exports.MapperDialog = void 0;
var _path2 = _interopRequireDefault(require("ramda/src/path"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _queryString = require("query-string");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _UI = require("../../../Utils/UI");
var _RestAPI = require("../../API/RestAPI");
var _Translator = require("../../Core/Translator");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
var _TimelineSubscription = require("../../Timeline/TimelineSubscription");
var _WidgetLoadingSpinner = require("../../Widgets/common/WidgetLoadingSpinner");
var _MapperDialogForm = require("./MapperDialogForm");
var _mappingTypePartMappi;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var MapDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "MapperDialog__MapDialog",
  componentId: "sc-1xatrnk-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);
var mappingTypePartMapping = (_mappingTypePartMappi = {}, _mappingTypePartMappi[_timelineDefinitions.TIME_SERIES_KIND] = "part_kind", _mappingTypePartMappi[_timelineDefinitions.TIME_SERIES_INSTANCE] = "part_instance", _mappingTypePartMappi[_timelineDefinitions.TIME_SERIES_PROCESS] = "part_process", _mappingTypePartMappi[_timelineDefinitions.TIME_SERIES_OPERATOR] = "operator", _mappingTypePartMappi);
var useExistingMapping = function useExistingMapping(_ref) {
  var device = _ref.device,
    type = _ref.type,
    toggleDialog = _ref.toggleDialog;
  var _useState = (0, _react.useState)(false),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    mappings = _useState2[0],
    setMappings = _useState2[1];
  var api = _react["default"].useContext(_RestAPI.RestAPIContext);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  (0, _react.useEffect)(function () {
    setLoading(true);
    api.get("/api/v3/part-operator-mapping/value-mapping?" + (0, _queryString.stringify)({
      device: device.uuid,
      type: type
    })).then(function (mappings) {
      setMappings(mappings);
      setLoading(false);
    })["catch"](function () {
      setLoading(false);
      toggleDialog();
      (0, _UI.showErrorToaster)(translate("MapDialog.fetchMappings.error", "Failed to fetch mappings"));
    });
  }, []);
  return {
    loading: loading,
    mappings: mappings
  };
};
var getMapping = function getMapping(mappings, device, type) {
  return mappings.find(function (mapping) {
    return mapping.device === device.uuid && mapping.type === type;
  });
};
var getMappingValue = function getMappingValue(mappings, device, type, originalValue) {
  var mapping = getMapping(mappings, device, type);
  if (!mapping) {
    return "";
  }
  var values = mapping.values;
  return values && values[originalValue] ? values[originalValue] : "";
};
var getMappingTimelineNormalizer = function getMappingTimelineNormalizer(timelineName) {
  return function (doc) {
    var originalValuePath = ["attributes", "dimensions", mappingTypePartMapping[timelineName], "original"];
    var mappingValuePath = ["dimensions", mappingTypePartMapping[timelineName]];
    var original = (0, _path2["default"])(originalValuePath)(doc);
    var mapped = (0, _path2["default"])(mappingValuePath)(doc);
    var mappedValue = original && mapped ? mapped : "";
    var originalValue = original && mapped ? original : mapped ? mapped : "";
    return {
      originalValue: originalValue ? originalValue : mappedValue
    };
  };
};
var handleSubmit = function handleSubmit(_ref2) {
  var packet = _ref2.packet,
    inputMapping = _ref2.inputMapping,
    setSubmittingStatus = _ref2.setSubmittingStatus,
    mapPartValue = _ref2.mapPartValue,
    device = _ref2.device,
    type = _ref2.type,
    toggleDialog = _ref2.toggleDialog;
  return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(packet && packet.originalValue && inputMapping)) {
            _context.n = 2;
            break;
          }
          setSubmittingStatus(true);
          _context.n = 1;
          return mapPartValue(device, type, packet.originalValue, inputMapping);
        case 1:
          setSubmittingStatus(false);
          toggleDialog();
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
};
var MapperDialog = exports.MapperDialog = function MapperDialog(props) {
  var label = props.label,
    partLabel = props.partLabel,
    partMappingInputPlaceholder = props.partMappingInputPlaceholder,
    type = props.type,
    device = props.device,
    timelineName = props.timelineName,
    toggleDialog = props.toggleDialog;
  var _useState3 = (0, _react.useState)(""),
    inputMapping = _useState3[0],
    setInputMapping = _useState3[1];
  var _useState4 = (0, _react.useState)(false),
    submittingStatus = _useState4[0],
    setSubmittingStatus = _useState4[1];
  var _React$useContext2 = _react["default"].useContext(_ManualEventsContext.ManualEventsContext),
    mapPartValue = _React$useContext2.mapPartValue;
  var onInputMappingChange = function onInputMappingChange(event) {
    return setInputMapping(event.target.value);
  };
  var _useExistingMapping = useExistingMapping({
      device: device,
      type: type,
      toggleDialog: toggleDialog
    }),
    loading = _useExistingMapping.loading,
    mappings = _useExistingMapping.mappings;
  return /*#__PURE__*/_react["default"].createElement(_TimelineSubscription.TimelineSubscription, {
    defaultValue: null,
    timelineName: timelineName,
    query: {
      device: device.uuid
    },
    isCurrent: true,
    normalize: getMappingTimelineNormalizer(timelineName)
  }, function (packet) {
    var originalValue = packet ? packet.originalValue : "";
    return /*#__PURE__*/_react["default"].createElement(MapDialog, {
      isOpen: props.isOpen,
      onClose: props.toggleDialog,
      icon: _icons.IconNames.COG,
      title: label
    }, loading ? /*#__PURE__*/_react["default"].createElement(_WidgetLoadingSpinner.WidgetLoadingSpinner, {
      width: 500,
      height: 100
    }) : /*#__PURE__*/_react["default"].createElement(_MapperDialogForm.MapperDialogForm, {
      isSubmitting: submittingStatus,
      isDisabled: packet ? !packet.originalValue : true,
      mappedValue: getMappingValue(mappings, device, type, originalValue),
      originalValue: originalValue,
      label: partLabel,
      inputProps: {
        value: inputMapping,
        onChange: onInputMappingChange,
        placeholder: partMappingInputPlaceholder
      },
      onSubmit: handleSubmit({
        packet: packet,
        inputMapping: inputMapping,
        setSubmittingStatus: setSubmittingStatus,
        mapPartValue: mapPartValue,
        device: device,
        type: type,
        toggleDialog: toggleDialog
      })
    }));
  });
};